module.exports = __webpack_public_path__ + "img/music-work-icon5.4df8eb46.png";